import { styled, Button } from '@withjoy/joykit';
import chroma from 'chroma-js';

const googleBackground = '#F9F9F9';
const facebookBackground = '#3A5A97';

const googleBackgroundHover = chroma(googleBackground)
  .darken(0.5)
  .hex();
const facebookBackgroundHover = chroma(facebookBackground)
  .darken(0.5)
  .hex();

export const GoogleButton = styled(Button)`
  background-color: ${googleBackground};
  min-width: unset;
  width: 3rem;
  padding: unset;
  transition: background-color 0.5s ease;
  :hover {
    background-color: ${googleBackgroundHover} !important;
  }
`;

export const FacebookButton = styled(Button)`
  background-color: ${facebookBackground};
  min-width: unset;
  width: 3rem;
  padding: unset;
  transition: background-color 0.5s ease;
  :hover {
    background-color: ${facebookBackgroundHover} !important;
  }
`;
